import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { FaBookOpen, FaSave } from "react-icons/fa";

import {
  REGLEMENT_QUILL_FORMATS,
  REGLEMENT_QUILL_MODULES,
} from "../utils/reglementInterieurUtils";

function SkeletonCard() {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="space-y-4 p-5">
        <div className="h-12 animate-pulse rounded-2xl bg-slate-100 dark:bg-slate-800" />
        <div className="h-72 animate-pulse rounded-2xl bg-slate-100 dark:bg-slate-800" />
      </div>
    </section>
  );
}

export default function ReglementEditorCard({
  formId,
  settings,
  loading,
  saving,
  onContentChange,
  onSubmit,
}) {
  if (loading) return <SkeletonCard />;

  return (
    <form
      id={formId}
      onSubmit={onSubmit}
      className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900"
    >
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-5">
          <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
            Contenu
          </p>

          <h3 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
            <FaBookOpen className="text-indigo-600 dark:text-indigo-300" />
            Texte du règlement intérieur
          </h3>

          <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
            Utilisez les titres, paragraphes et listes pour obtenir un règlement
            clair, lisible et facilement consultable par les adhérents.
          </p>
        </div>

        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-950 quill-wrapper">
          <ReactQuill
            value={settings.reglement_interieur || ""}
            onChange={(value) =>
              onContentChange("reglement_interieur", value)
            }
            theme="snow"
            formats={REGLEMENT_QUILL_FORMATS}
            modules={REGLEMENT_QUILL_MODULES}
            placeholder="<p>Rédigez ici le règlement intérieur du club…</p>"
          />
        </div>

        <div className="mt-4 rounded-[24px] border border-indigo-200 bg-indigo-50 p-4 dark:border-indigo-500/20 dark:bg-indigo-500/10">
          <p className="text-sm font-bold text-indigo-800 dark:text-indigo-200">
            Conseil de présentation
          </p>

          <p className="mt-1 text-sm leading-6 text-indigo-700 dark:text-indigo-300">
            Structurez le règlement avec des titres : adhésion, comportement,
            sécurité, cotisation, droit à l’image, responsabilité, sanctions,
            vie du club.
          </p>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-5 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-[#012f6d] disabled:cursor-not-allowed disabled:opacity-60 dark:bg-indigo-500 dark:hover:bg-indigo-400"
          >
            <FaSave />
            {saving ? "Enregistrement..." : "Mettre à jour"}
          </button>
        </div>
      </div>

      <style>{`
        .quill-wrapper .ql-toolbar.ql-snow {
          border: 0;
          border-bottom: 1px solid #e2e8f0;
          background: #ffffff;
        }

        .quill-wrapper .ql-container.ql-snow {
          border: 0;
          min-height: 360px;
        }

        .quill-wrapper .ql-editor {
          min-height: 360px;
          font-size: 14px;
          line-height: 1.75;
        }

        .dark .quill-wrapper .ql-toolbar.ql-snow {
          background: rgba(15,23,42,.98);
          border-color: #334155;
        }

        .dark .quill-wrapper .ql-container.ql-snow {
          background: rgba(2,6,23,.7);
        }

        .dark .quill-wrapper .ql-editor {
          color: #e2e8f0;
        }

        .dark .ql-snow .ql-stroke {
          stroke: #e2e8f0 !important;
        }

        .dark .ql-snow .ql-fill {
          fill: #e2e8f0 !important;
        }

        .dark .ql-snow .ql-picker,
        .dark .ql-snow .ql-picker-label,
        .dark .ql-snow .ql-picker-options,
        .dark .ql-snow .ql-toolbar button {
          color: #e2e8f0 !important;
        }

        .dark .ql-snow .ql-picker-options {
          background: #0b1220;
          border-color: #334155;
        }

        .dark .ql-editor strong,
        .dark .ql-editor b {
          color: #fff;
        }
      `}</style>
    </form>
  );
}